import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@ot/shared/model';
import * as jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Environment, EnvironmentConfigService } from '../environment';
import { PlatformServiceName } from './../environment/environment.model';
import { UserProfile } from './user-profile.model';
import { GUID_TO_UUID_REGEX } from '../constants/constants';

export const USER_PROFILE_KEY = 'user_profile';
/**
 * Consolidated logging service to log and send data to server for further processing
 */
@Injectable({
  providedIn: 'root'
})
export class UserService {
  _businessAccount: string;
  _serviceUrl = null;
  constructor(
    @Inject(ENVIRONMENT) private environment: Environment,
    private httpClient: HttpClient,
    private environmentConfigService: EnvironmentConfigService
  ) {
    this._serviceUrl =
      this.environmentConfigService.getEnvironmentConfigs().apis.ifta.url +
      '/' +
      this.environment.serviceUrlList[PlatformServiceName.UserService];
  }

  setUserProfile(username: string): Observable<UserProfile> {
    return this.httpClient
      .get(`${this._serviceUrl}/users/${username}`)
      .pipe(
        tap((userProfile: UserProfile) =>
          localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(userProfile))
        )
      );
  }
  getUserProfile(): UserProfile {
    return (
      localStorage.getItem(USER_PROFILE_KEY) &&
      JSON.parse(localStorage.getItem(USER_PROFILE_KEY))
    );
  }
  getBusinessAccount(): string {
    if(this.getAccessTokenFromLocalStorage()){
      const overrideBaid = localStorage.getItem('selectedBaid');
      if (overrideBaid) {
        return overrideBaid;
      }
      const guid = jwt_decode(this.getAccessTokenFromLocalStorage())['co'];
      this._businessAccount = guid.toLowerCase().replace(GUID_TO_UUID_REGEX, "$1-$2-$3-$4-$5");
      return this.getUserProfile()
        ? this.getUserProfile().user.businessAccountId.value
        : this._businessAccount;
    }
  }

  getAccessTokenFromLocalStorage() {
    return localStorage.getItem('access_token');
  }
  /**
   * Set business account from the access token
   * @param accesToken the access token to retrieve business account
   * @param fieldName the name of the field to retrieve the token
   */
  setBusinessAccountFromAccessToken(accesToken: string, fieldName: string) {
    const guid = jwt_decode(accesToken)[fieldName];
    this._businessAccount = guid.toLowerCase().replace(GUID_TO_UUID_REGEX, "$1-$2-$3-$4-$5");
  }
  hasAdministratorPrivileges(accessToken: string) {
    const token = jwt_decode(accessToken);
    // @TODO: when full role based auth is added, this should be revised.
    // return ['subject', 'email', 'sub'].some(key =>
    return ['uid', 'sub', 'usrprofile'].some(key =>
      this.isAdminAccountDomain(token[key])
    );
  }
  private isAdminAccountDomain(emailAddress: string) {
    if (emailAddress) {
      const atIndex = emailAddress.lastIndexOf('@');
      // return atIndex >= 0
      //   ? emailAddress.substring(atIndex) === '@omnitracs.com'
      //   : false;
      //The above lines are commented because Unity doesn't have email address. so, I'm using usrprofile instead.
      if ( atIndex < 0 && emailAddress === 'I') {
        return true;
      }
    }
    return false; // if no email address.
  }

  getDecodedToken(accessToken: string) {
    return jwt_decode(accessToken);
  }
}
